import { createApp } from 'vue'
// import ElementPlus from 'element-plus';
// import 'element-plus/theme-chalk/index.css';
// import { ElMessage } from 'element-plus';
// import 'element-plus/theme-chalk/el-message.css';
import App from './App.vue'
import router from '@/router'

// createApp(App).use(router).use(ElementPlus).mount('#app');
// createApp(App).use(router).use(ElMessage).mount('#app');
createApp(App).use(router).mount('#app');